const BASE = process.env.REACT_APP_API_URL || '';

function getToken() {
  return localStorage.getItem('admin_token');
}

async function request(method, path, body) {
  const res = await fetch(`${BASE}/api${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {})
    },
    ...(body ? { body: JSON.stringify(body) } : {})
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
}

export const api = {
  login: (username, password) => request('POST', '/login', { username, password }),
  getSites: () => request('GET', '/sites'),
  deploySite: (domain, options) => request('POST', '/sites/deploy', { domain, options }),
  previewSite: (domain, options) => request('POST', '/sites/preview', { domain, options }),
  siteAction: (domain, action) => request('POST', `/sites/${domain}/action`, { action }),
  deleteSite: (domain) => request('DELETE', `/sites/${domain}`),
  getCompose: (domain) => request('GET', `/sites/${domain}/compose`),
  updateCompose: (domain, compose) => request('PUT', `/sites/${domain}/compose`, { compose }),
  getCredentials: (domain) => request('GET', `/sites/${domain}/credentials`),
  getQuota: (domain) => request('GET', `/sites/${domain}/quota`),
  setQuota: (domain, sizeGB) => request('PUT', `/sites/${domain}/quota`, { sizeGB }),
  getNetworks: () => request('GET', '/docker/networks'),
};
